import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';
import {Router, ActivatedRoute} from '@angular/router';
import { EmitterService } from '../services/emitter.service';
import { Subscription } from 'rxjs/Subscription';

let headers = new Headers();
headers.append("Content-Type", "application/json");
headers.append('Access-Control-Allow-Origin', '*');


@Injectable()
export class AjaxService {

  public subscriptions: Array<Subscription> = [];
    constructor(private http: Http,private _emitterService: EmitterService, public _router: Router) {}


    AjaxCall(url: string, callback) {
      const thisObj = this;
      this._emitterService.setSpinner(true);
        this.http.get(url, {headers: headers})
            .subscribe(
                (data) => {
                  const res = data.json();//For Success Response
                    // for timer popup
                    thisObj._emitterService.setSpinner(false);
                    callback(res);
                },
                err => {
                    thisObj._emitterService.setSpinner(false)
                }
            );
    }

    PostAjaxCall(url: string, params: any, callback) {
      const thisObj = this;
      this._emitterService.setSpinner(true);
        this.http.post(url, params)
            .subscribe(
                (data) => {
                  const res = data.json();//For Success Response
                    // for timer popup
                    thisObj._emitterService.setSpinner(false);
                    callback(res);
                },
                err => {                    
                    thisObj._emitterService.setSpinner(false)
                }
            );
    }
    loginAjax(url: string, params: any, callback) {
      const thisObj = this;
      thisObj._emitterService.setSpinner(true);
        this.http.post(url, params)
            .subscribe(
                (data) => {
                    thisObj._emitterService.setSpinner(false);
                  const res = data.json();//For Success Response
                    callback(res);
                },
                err => {
                    thisObj ._emitterService.setSpinner(false);
//                    localStorage.clear();
//                    localStorage.setItem('islogin', '1');
                    sessionStorage.clear();
                    sessionStorage.setItem('islogin', '1');
                    thisObj._router.navigate(['login']);
                }
            );
    }
    
 

}



// WEBPACK FOOTER //
// ./src/app/modules/housekeeping/services/ajax.service.ts